import React, { Component } from 'react';
import { Element } from 'react-scroll';
import cn from 'classnames';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import i18n from '../../../i18n';
import { ROOT_URL } from 'constants/Config.js';
import ClientHeader from 'components/Header/ClientHeader';
import BuildingTitle from 'components/Header/BuildingTitle';
import RealtorCard from 'components/RealtorCard';
import FlatsList from 'components/FlatsList';
import Footer from 'components/Footer';
import Gallery from './Gallery/Gallery';
import Info from './Info/Info';
import About from './About/About';
import Features from './Features';
import Housing from './Housing/Housing';
import Description from './Description/Description';
import Developer from './Developer/Developer';
import Suggestions from './Suggestions';
import Formalization from './Formalization/Formalization';
import Contacts from './Contacts/Contacts';
import Payment from './Payment/Payment';
import Nav from './Nav';
import Documents from './Documents/Documents';
import News from './News/News';
import Popup from './Popup/Popup';
import List from './Popup/List/List';
import LeftWireframe from './LeftWireframe';
import RightWireframe from './RightWireframe';
import SuggestionsWireframe from './SuggestionsWireframe';
import ImageGallery from 'components/Building/Main/ImageGallery/src/ImageGallery';
import ProgressiveImage from 'components/common/ProgressiveImage';
import NoPage from 'components/ClientCollection/NoPage';
import iconClose from 'assets/images/icons/close-popup-gallery.svg';

import ScrollLock from 'components/ScrollLock';
import Sticky from 'react-sticky-el';
import IconMap from 'react-icons/lib/fa/map';
import iconPhotos from 'assets/images/icons/icon-photos.svg';
import Loader from './Loader';
import noFloor from 'assets/images/no-floor.png';

import { YCaption, YMapPoint, YMap } from 'components/common/YMap';

import styles from './Main.scss';
import googleMapImgEmpty from 'assets/images/map-preview.png';
import googleMapImg from 'assets/images/map-preview.png';

import { getBuildingType, getLotsType, isSectionAllowed } from './helper';
import features from 'constants/Features';

const monthToString = (n) => {
  switch (n) {
    case 1:
      return i18n.t('components.building.main.main.month.1');
    case 2:
      return i18n.t('components.building.main.main.month.2');
    case 3:
      return i18n.t('components.building.main.main.month.3');
    case 4:
      return i18n.t('components.building.main.main.month.4');
    case 5:
      return i18n.t('components.building.main.main.month.5');
    case 6:
      return i18n.t('components.building.main.main.month.6');
    case 7:
      return i18n.t('components.building.main.main.month.7');
    case 8:
      return i18n.t('components.building.main.main.month.8');
    case 9:
      return i18n.t('components.building.main.main.month.9');
    case 10:
      return i18n.t('components.building.main.main.month.10');
    case 11:
      return i18n.t('components.building.main.main.month.11');
    case 12:
      return i18n.t('components.building.main.main.month.12');
    default:
      return '';
  }
};

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPopUp: false,
      currentAlbum: 0,
      currentPhoto: 0,
      currentAlbumPhoto: 0,
      isMap: null
    };

    this.changePopUpState = this.changePopUpState.bind(this);
    this.setAlbumFromGalleryData = this.setAlbumFromGalleryData.bind(this);
    this.changeCurrentPhoto = this.changeCurrentPhoto.bind(this);
    this.togglePopUpRender = this.togglePopUpRender.bind(this);
    this.handleGalleryClick = this.handleGalleryClick.bind(this);
    this._onSlide = this._onSlide.bind(this);
  }

  map = null;

  componentDidMount() {
    document.body.scrollTop = 0;
  }

  changePopUpState(isPopUp, isMap, currentPhoto, currentAlbum, currentAlbumPhoto) {
    this.setState({
      isPopUp,
      isMap
    });

    if (typeof currentPhoto === 'number') {
      this.setState({
        currentPhoto
      });
    }
    if (typeof currentAlbum === 'number') {
      this.setState({
        currentAlbum
      });
    }
    if (typeof currentAlbumPhoto === 'number') {
      this.setState({
        currentAlbumPhoto
      });
    }
  }

  changeCurrentPhoto(currentPhoto, currentAlbumPhoto, cb) {
    this.setState({ currentPhoto }, cb);

    if (currentAlbumPhoto) {
      this.setState({ currentAlbumPhoto }, cb);
    }
  }

  togglePopUpRender(isMap) {
    this.setState({ isMap });
  }

  _onSlide(galleryData, index) {
    this.setAlbumFromGalleryData(index, galleryData);
  }

  setAlbumFromGalleryData(index, galleryData = {}) {
    this.changeCurrentPhoto(index);

    galleryData.metaForGallery.meta.forEach((a, i) => {
      if (a.first <= index && index < a.last) {
        this.setState({
          currentAlbum: i,
          currentAlbumPhoto: index - a.first
        });
      }
    });
  }

  genItemsForGallery(albums) {
    return albums && albums.rows
      ? albums.rows.reduce((p, c) => {
        const images = c.images
            ? c.images.map((img) => {
              const fullDefaultSize = 'original';
              // const smallDefaultSize = 'medium';

              return {
                thumbnail: () => `${ROOT_URL}/image?id=${img.id}&size=${fullDefaultSize}`,
                original: () => `${ROOT_URL}/wimage?id=${img.id}&size=${fullDefaultSize}`
              };
            })
            : {};
        return [...p, ...images];
      }, [])
      : [];
  }

  genMetaForGallery(albums) {
    return albums && albums.rows
      ? albums.rows.reduce(
          (p, c) => ({
            total: p.total + (c.images ? c.images.length : 0),
            meta: [
              ...p.meta,
              {
                name: c.type.name,
                year: c.year,
                month: monthToString(c.month),
                first: p.total,
                last: p.total + (c.images ? c.images.length : 0)
              }
            ]
          }),
          { total: 0, meta: [] },
        )
      : [];
  }

  renderPopupMapContent(latitude, longitude, finished, onClose) {
    const { selection, building, t } = this.props;

    let contexuality;
    // У нашего бекендера где-то это строка, где-то цифра. Хер проссышь.
    if (Number(building.data.count_flats) === 0) {
      contexuality = 'disabled';
    } else {
      contexuality = building.data.status == 3 ? 'almostFinished' : finished ? 'success' : 'warningSuccess';
    }

    return (
      <div className={styles.PopUpMap}>
        <div className={styles.Header}>
          <h3 className={styles.Title}>
            {selection && selection.showInfo === '0' ? null : `${building.data.title} / `}
            <span className={styles.Bold}>
              {t('components.building.main.main.onMap')}
            </span>
            <div className={styles.Close} onClick={onClose}>
              <img alt="close" src={iconClose} />
            </div>
          </h3>
        </div>
        <ScrollLock>
          <div className={styles.MapWrapper}>
            {this.renderMap(latitude, longitude, contexuality)}
          </div>
        </ScrollLock>
      </div>
    );
  }

  renderMap(latitude, longitude, contexuality) {
    const city = this.props.cities.find((city) =>
      city.regions.map((region) => region.id).includes(this.props.building.data.region.id),
    );
    const region = city.regions.find((reg) => reg.id === this.props.building.data.region.id);
    const {
      name,
      latitude: lat,
      longitude: lng
    } = region.subregions.find((reg) => reg.id === this.props.building.data.subregion.id);
    const showPoint =
      !this.props.selection || (this.props.selection && this.props.selection.showInfo === '1');

    return (
      <YMap
        defaultState={{
          center: [latitude - 0.00019, longitude + 0.00015],
          zoom: showPoint ? 17 : 12
        }}
      >
        {showPoint ? <YMapPoint lat={latitude} lng={longitude} contexuality={contexuality} /> : null}
        <YCaption lat={lat} lng={lng} name={name} />
      </YMap>
    );
  }

  makeRenderGalleryItem(props = {}) {
    return (item) => (
      <div className={styles.GalleryImage}>
        <ProgressiveImage
          className={props.popupGallery ? styles.ProgressiveImageBigGallery : ''}
          isPopup={!!props.popupGallery}
          getSmallImageSrc={item.thumbnail}
          getBigImageSrc={item.original}
          width={props.width || null}
        />
        {item.description ? (
          <span className={styles.GalleryDescription}>{item.description}</span>
        ) : null}
      </div>
    );
  }

  handleGalleryClick() {
    this._imagePopUpGallery.slideToIndex(this._imagePopUpGallery.getCurrentIndex() + 1);
  }

  renderGallery = (galleryData, albums, currentAlbum, one, onClose) => {
    const album = albums.rows[currentAlbum];
    const { t } = this.props;
    const {
      type: { name }
    } = album;
    const hasAlbums = albums.rows.length > 1;
    const months = [
      t('components.building.main.main.month.1'),
      t('components.building.main.main.month.2'),
      t('components.building.main.main.month.3'),
      t('components.building.main.main.month.4'),
      t('components.building.main.main.month.5'),
      t('components.building.main.main.month.6'),
      t('components.building.main.main.month.7'),
      t('components.building.main.main.month.8'),
      t('components.building.main.main.month.9'),
      t('components.building.main.main.month.10'),
      t('components.building.main.main.month.11'),
      t('components.building.main.main.month.12')
    ];

    return (
      <div className={cn(styles.PopUpGallery, { [styles.WithAlbums]: hasAlbums })}>
        <style>
          {`
              html {
                overflow: hidden;
              }
            `}
        </style>
        <div className={styles.PopUpGalleryInner}>
          <div className={styles.Header}>
            <h3 className={styles.Title}>
              {!(this.props.selection && this.props.selection.showInfo === '0') &&
                `${this.props.building.data.title} / `}
              <span className={styles.Bold}>
                {album.type.name === 'Ход строительства'
                  ? ` ${months[album.month - 1]} ${album.year}`
                  : name}
              </span>
              <div className={styles.Close} onClick={onClose}>
                <img alt="close" src={iconClose} />
              </div>
            </h3>
            <div className={cn(styles.Count, styles.ShowMobile)}>
              {t('components.building.main.main.photo', {
                number: this.state.currentAlbumPhoto ? this.state.currentAlbumPhoto + 1 : 1,
                allNumber: album.images.length
              })}
            </div>
          </div>

          <div className={styles.Slider}>
            <div className={cn(styles.Count, styles.HideMobile)}>
              {t('components.building.main.main.photo', {
                number: this.state.currentAlbumPhoto ? this.state.currentAlbumPhoto + 1 : 1,
                allNumber: album.images.length
              })}
            </div>
            <ImageGallery
              ref={(i) => (this._imagePopUpGallery = i)}
              showIndex={false}
              startIndex={this.state.currentPhoto}
              onClick={this.handleGalleryClick}
              onSlide={this._onSlide.bind(this, galleryData)}
              slideOnThumbnailHover={false}
              showBullets={false}
              lazyLoad={true}
              infinite={true}
              isShort={this.state.isPopUp}
              showThumbnails
              showFullscreenButton={false}
              showGalleryFullscreenButton={false}
              showPlayButton={false}
              showGalleryPlayButton={false}
              showNav={true}
              renderItem={this.makeRenderGalleryItem({ popupGallery: true })}
              items={galleryData.itemsForGallery}
            />
          </div>

          {hasAlbums ? (
            <div className={styles.ListContainer}>
              <ScrollLock>
                <List
                  galleryData={galleryData}
                  albums={albums}
                  currentAlbum={currentAlbum}
                  onImage={this.changePopUpState.bind(
                    this,
                    true,
                    false,
                    undefined,
                    undefined,
                    undefined,
                  )}
                  galleryRef={this._imagePopUpGallery}
                />
              </ScrollLock>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  renderGalleryComponent = (props) => {
    const galleryData = {
      itemsForGallery: this.genItemsForGallery(props.building.data.albums),
      metaForGallery: this.genMetaForGallery(props.building.data.albums)
    };

    return (
      <Gallery
        {...props}
        className={styles.GalleryComponent}
        galleryData={galleryData}
        setAlbumFromGalleryData={this.setAlbumFromGalleryData}
        changeCurrentPhoto={this.changeCurrentPhoto}
        openPopUp={this.changePopUpState.bind(this, true, false)}
        onImage={this.togglePopUpRender.bind(this, false)}
        onMap={this.togglePopUpRender.bind(this, true)}
        renderItem={this.makeRenderGalleryItem()}
      />
    );
  };

  renderPopup(building) {
    const { latitude, longitude, pavilions, albums } = building.data;

    const finished = (pavilions || []).some((pavilion) => {
      const { construction_finished } = pavilion;
      return construction_finished;
    });

    const galleryData = {
      itemsForGallery: this.genItemsForGallery(albums),
      metaForGallery: this.genMetaForGallery(albums)
    };

    return (
      <Popup
        isOpen={this.state.isPopUp}
        className={cn(
          this.state.isPopUp ? styles.OpenPopup : '',
          this.state.isMap ? styles.OpenPopupMap : '',
        )}
        render={() =>
          this.state.isMap
            ? this.renderPopupMapContent(
                latitude,
                longitude,
                finished,
                this.changePopUpState.bind(this, false),
              )
            : this.renderGallery(
                galleryData,
                albums,
                this.state.currentAlbum,
                albums.length === 1,
                this.changePopUpState.bind(this, false),
              )
        }
      />
    );
  }

  renderHeaderMap = () => {
    const { selection } = this.props;
    const showMapWithPoint = !!selection && selection.showInfo === '1';

    return (
      <div className={styles.HeaderMap}>
        <img
          alt=""
          src={showMapWithPoint ? googleMapImg : googleMapImgEmpty}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center center'
          }}
        />
      </div>
    );
  };

  handleClientGalleryClick = (i, galleryData) => {
    this.setAlbumFromGalleryData(i, galleryData);
    this.changePopUpState.bind(this, true, false)();
  };

  renderImages = (galleryData, max) =>
    galleryData.itemsForGallery
      .slice(0, max)
      .map(({ original }, i) => (
        <img
          ref={`image_${i}`}
          src={original(this.refs[`image_${i}`])}
          alt=""
          key={i}
          onClick={this.handleClientGalleryClick.bind(this, i, galleryData)}
        />
      ));

  renderMaxHeaderImages = (max) => {
    const { albums = [] } = this.props.building.data || {};
    const galleryData = {
      itemsForGallery: this.genItemsForGallery(albums),
      metaForGallery: this.genMetaForGallery(albums)
    };
    if (galleryData.itemsForGallery.length <= 3 || max <= 3) {
      return (
        <div className={styles.GalleryHeaderInnerBlur}>
          <svg height="100" width="100">
            <defs>
              <filter id="blur" x="0" y="0">
                <feGaussianBlur in="SourceGraphic" stdDeviation="14" />
              </filter>
            </defs>
          </svg>
          <img
            src={galleryData.itemsForGallery[0] ? galleryData.itemsForGallery[0].original : ''}
            alt=""
            key="thumb"
            onClick={this.handleClientGalleryClick.bind(this, 0)}
            className={styles.BlurredImage}
          />
          {this.renderImages(galleryData, Math.min(3, max))}
        </div>
      );
    }
    return <div className={styles.GalleryHeaderInner}>{this.renderImages(galleryData, max)}</div>;
  };

  renderHeaderImages = this.renderMaxHeaderImages.bind(this, 6);

  renderHeaderImage = this.renderMaxHeaderImages.bind(this, 1);

  renderForClient = () => {
    const { ...rest } = this.props;
    const { building, user, selection, match, noPageExist, t } = this.props;
    const { params } = match;
    const { region, subregion, comment } = building.data || {};
    if (noPageExist) {
      return (
        <div className={cn(styles.Building, styles.Client)}>
          <Helmet>
            <title>
              {t('components.building.main.main.title', {
                title: selection.showInfo === '1' ? `${this.props.building.data.title} -` : ''
              })}
            </title>
          </Helmet>
          <ClientHeader params={params}>
            <NoPage />
          </ClientHeader>
        </div>
      );
    }

    let galleryImagesCount = 0;
    let pavilions,
      deadline,
      finished;
    if (building.data) {
      if (building.data.albums.rows) {
        for (let i = 0; i < building.data.albums.rows.length; i++) {
          galleryImagesCount += building.data.albums.rows[i].images ? building.data.albums.rows[i].images.length : 0;
        }
      }

      let year,
        quarter;
      pavilions = building.data.pavilions;
      let check = 20994; // 2099 г. 4 кв.
      finished = (pavilions || []).some((pavilion) => {
        const { construction_finished, year_built, construction_ending } = pavilion;
        const current = Number(`${year_built}${construction_ending}`);
        if (year_built && construction_ending && check > current) {
          check = current;
          year = year_built;
          quarter = construction_ending;
        }
        return construction_finished;
      });
      deadline = finished
        ? t('components.building.main.main.finished')
        : year === 0
        ? t('components.building.main.main.inProgress')
        : year && quarter
        ? `${quarter} / ${year}`
        : '';
    }

    return (
      <div className={cn(styles.Building, styles.Client)}>
        {building.isLoading || !building.data ? (
          <Loader className={styles.ObjectPageLoader} />
        ) : (
          <React.Fragment>
            <Helmet>
              <title>
                {t('components.building.main.main.title', {
                  title: selection.showInfo === '1' ? `${this.props.building.data.title} -` : ''
                })}
              </title>
            </Helmet>
            <ClientHeader params={params}><div className={styles.ContainerWrapper}>
              <Element name="photo">
                <div className={styles.GalleryHeader}>
                  {galleryImagesCount ? (
                    <button
                      className={styles.GalleryButton}
                      onClick={this.changePopUpState.bind(this, true, false)}
                    >
                      <img src={iconPhotos} alt="" /> {t('components.building.main.main.allOnMap', { galleryImagesCount })}
                    </button>
                      ) : null}

                  {this.props.client && galleryImagesCount === 0 ? (
                    <div className={styles.GalleryEmptyHeaderInner}>
                      <img src={noFloor} alt="" />
                      <div>
                        {t('components.building.main.main.noViews')}
                      </div>
                    </div>
                      ) : (
                        this.renderHeaderImages()
                      )}

                  <div className={styles.Status}>
                    <div
                      className={cn(finished ? styles.Green : styles.Yellow, styles.StatusBlock)}
                    >
                      {deadline}
                    </div>
                  </div>
                </div>
              </Element>
              <div className={styles.Container} id="container-main">
                <div className={styles.LeftRow}>
                  <div className={styles.NavWrapper}>
                    <Nav {...rest} />
                  </div>
                  {comment && (
                    <div className={styles.CommentBlock}>
                      <div className={styles.CommentAuthor}>
                        <img
                          src={
                                user.avatarId
                                  ? `${ROOT_URL}/image/get?id=${user.avatarId}&preset=profile_avatar`
                                  : 'https://nedvex.ru/static/media/icon-user.553f82d8.svg'
                              }
                          alt=""
                        />
                        <div className={styles.CommentAuthorName}>{user.firstName}</div>
                      </div>
                      <div className={styles.CommentMain}>
                        <div className={styles.CommentText}>
                          <span className={styles.Arrow}></span>
                          <p>{comment}</p>
                        </div>
                      </div>
                    </div>
                      )}
                  {<BuildingTitle {...rest} client showInfo={selection.showInfo} />}
                  <Element name="info">
                    <Info {...rest} client />
                  </Element>
                  {isSectionAllowed('description') && (building.data.description ||
                        Object.keys(features).some((feature) => building.data[feature])) && (
                        <div className={styles.DescriptionAndFeatures}>
                          {selection.showInfo === '1' && (
                            <Description {...rest} className={styles.Description} />
                          )}
                          <Features {...rest} className={cn(styles.Features)} />
                        </div>
                  )}
                  {(isSectionAllowed('characteristics') || isSectionAllowed('communications')) && <About {...rest} />}
                  <div className={styles.FormalizationAndPaymentWrap}>
                    {isSectionAllowed('checkout') && <Formalization {...rest} />}
                    {isSectionAllowed('payment') && building.data.count_flats ? <Payment {...rest} /> : null}
                  </div>
                  {isSectionAllowed('map') && (<div className={styles.MapBlockWrap}>
                    <p className={styles.MapBlockTitle}>
                      {region.name}, {subregion.name}
                    </p>
                    <div
                      className={styles.MapBlock}
                      onClick={this.changePopUpState.bind(this, true, true)}
                    >
                      <div className={cn(styles.MapCover)}>
                        <div className={styles.Div}>
                          <IconMap className={styles.MapIcon} />
                          <span>
                            {t('components.building.main.main.lookOnMap')}
                          </span>
                        </div>
                      </div>
                      {this.renderHeaderMap()}
                    </div>
                  </div>)}
                  {building.data.type_id != 2 && <Housing {...rest} client />}
                  {getLotsType() > 0 && (
                    <Element name="flats">
                      <FlatsList {...rest} />
                    </Element>
                  )}
                </div>
                <div className={cn(styles.RightRow, styles.NotMobile)}>
                  <Sticky
                    stickyClassName={styles.stickyEl}
                    boundaryElement="#container-main"
                    bottomOffset={90}
                  >
                    {user && <RealtorCard {...user} />}
                  </Sticky>
                </div>
                {this.renderPopup(building)}
              </div>
            </div></ClientHeader>
          </React.Fragment>
        )}
      </div>
    );
  };

  renderForManager = () => {
    const { data, isBuildingLoading, t, ...rest } = this.props;
    const { building, withClient } = rest;

    return (
      <div className={styles.Building}>
        {isBuildingLoading || !building.data ? (
          <div>
            <div className={styles.Container}>
              <LeftWireframe className={styles.LeftRow} />
              <RightWireframe className={styles.RightRow} />
            </div>
            <SuggestionsWireframe />
          </div>
        ) : (
          <React.Fragment>
            <BuildingTitle {...rest} isBuildingLoading={isBuildingLoading} />
            <Helmet>
              <title>
                {t('components.building.main.main.title', {
                  title: `${this.props.building.data.title} -`
                })}
              </title>
            </Helmet>
            <div>
              <div className={styles.ContainerWrapper}>
                <div className={styles.Container}>
                  <div className={styles.LeftRow}>
                    {this.renderGalleryComponent(rest)}
                    <Info {...rest} />
                    <div className={cn(styles.RightRow, styles.OnlyMobile)}>
                      {!withClient && <News {...rest} />}
                      {!withClient && <Developer {...rest} />}
                      {!withClient && <Contacts {...rest} />}
                      <Documents {...rest} />
                    </div>
                    {building.data && building.data.description && (
                    <div className={styles.DescriptionTitle}>
                      {t('components.building.main.main.about', { type: getBuildingType(building.data.type_id) })}
                    </div>
                      )}
                    <Description {...rest} className={styles.Description} />
                    <Features {...rest} className={cn(styles.Features)} />
                    <About {...rest} />
                    <div className={styles.FormalizationAndPaymentWrap}>
                      <Formalization {...rest} />
                      {building.data.count_flats ? <Payment {...rest} /> : null}
                    </div>
                    {building.data.type_id != 2 && <Housing {...rest} />}
                  </div>
                  <div className={cn(styles.RightRow, styles.NotMobile)}>
                    {!withClient && <News {...rest} />}
                    {!withClient && <Developer {...rest} />}
                    {!withClient && <Contacts {...rest} />}
                    <Documents {...rest} />
                  </div>
                  {this.renderPopup(building)}
                </div>
              </div>
              <Suggestions {...rest} />
            </div>
          </React.Fragment>
        )}
        <Footer />
      </div>
    );
  };

  renderForPrint = () => {
    const { print, t, ...rest } = this.props;
    const { building } = rest;

    return (
      <div className={cn(styles.Building, styles.BuildingPrint)}>
        <div className={styles.PrintLoaderWrap}>
          <div className={styles.PrintLoader}></div>
          <div className={styles.PrintLoaderText}>
            {t('components.building.main.main.print')}
          </div>
        </div>

        {building.isLoading || !building.data ? (
          <div className={styles.Container}></div>
        ) : (
          <div className={cn(styles.Container, styles.PrintContainer)}>
            {print.desc && (
              <div className={cn(styles.LeftRow, styles.PrintSection, styles.PrintSectionDesc)}>
                <BuildingTitle {...rest} print={print} />
                <Description {...rest} print={print} />
              </div>
            )}
            {print.info && (
              <div className={styles.PrintSectionInfoWrapper}>
                <BuildingTitle {...rest} print={print} />
                <div className={cn(styles.PrintSectionInfo)}>
                  <div className={styles.LeftRow}>
                    <div className={styles.LeftRowPrintLeft}>
                      <About {...rest} print={print} />
                      <Features {...rest} print={print} />
                    </div>
                    <div className={styles.LeftRowPrintRight}>
                      <Formalization {...rest} print={print} />
                      {building.data.count_flats ? <Payment {...rest} print={print} /> : null}
                    </div>
                  </div>
                  {building.data.type_id != 2 && (
                    <div className={styles.RightRow}>
                      <Housing {...rest} print={print} />
                    </div>
                  )}
                </div>
              </div>
            )}
            {print.contacts && (
              <div className={cn(styles.PrintSection, styles.PrintSectionContacts)}>
                <BuildingTitle {...rest} print={print} />
                <Developer {...rest} print={print} />
                <Contacts {...rest} print={print} />
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { client, print } = this.props;

    if (client) {
      return this.renderForClient();
    }

    if (print) {
      return this.renderForPrint();
    }

    return this.renderForManager();
  }
}

export default withTranslation()(connect((state) => ({
  cities: state.building.cities
}))(Main));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Main.js